import actions from './actions'
import mutations from './mutations'

const DEFAULT_STATE = {
  history: null,
  current: null
}

const state = function () {
  return {
    ...DEFAULT_STATE
  }
}

const getters = {
}

const module = {
  state,
  getters,
  actions,
  mutations
}

export default module



// WEBPACK FOOTER //
// ./src/app/router/store/index.js